import CreateAxiosInstance from './axiosConfig';

const api = CreateAxiosInstance(import.meta.env.VITE_API_BASE_URL);
const options = { customErrorHandler: () => {}, sensitiveRequest: true };
const base = '/integrations/canva';

export const getCanvaStatus = async () => (await api.get(`${base}/status`, options)).data;
export const startCanvaExport = async (packetId, requestId, blockUniqueIds, title) =>
  (
    await api.post(
      `${base}/exports/${packetId}`,
      { request_id: requestId, block_unique_ids: blockUniqueIds, title },
      options
    )
  ).data;
export const getCanvaExport = async (jobId) =>
  (await api.get(`${base}/exports/${jobId}`, options)).data;

export const openCanvaExport = async (jobId) =>
  (await api.post(`${base}/exports/${jobId}/open`, {}, options)).data;

// Which Canva account is connected; the name is read live from Canva, never stored.
export const getCanvaAccount = async () => (await api.get(`${base}/account`, options)).data;
export const disconnectCanva = async () => (await api.post(`${base}/disconnect`, {}, options)).data;

// The Canva tab is opened by the caller straight from the click (pop-up blockers allow it
// only there). This drives it through Canva's sign-in and consent, then hands the code to
// the signed-in backend. The tab is left open: the caller navigates it on to the design.
export function authorizeCanvaInTab(tab, authorization, signal) {
  return new Promise((resolve, reject) => {
    let settled = false;
    const finish = (error) => {
      if (settled) return;
      settled = true;
      clearInterval(closedTimer);
      clearTimeout(timeout);
      window.removeEventListener('message', onMessage);
      signal?.removeEventListener('abort', onAbort);
      if (error) reject(error);
      else resolve();
    };
    const cancelled = () => {
      const error = new Error('The Canva window was closed before it finished.');
      error.code = 'cancelled';
      return error;
    };
    const onAbort = () => finish(cancelled());
    const onMessage = async (event) => {
      if (
        settled ||
        event.source !== tab ||
        event.origin !== authorization.callback_origin ||
        event.data?.type !== 'diffit-canva-oauth' ||
        event.data.state !== authorization.state
      )
        return;
      clearInterval(closedTimer);
      window.removeEventListener('message', onMessage);
      if (event.data.error || !event.data.code) {
        const error = new Error('Canva was not connected. You can try again.');
        error.code = 'cancelled';
        finish(error);
        return;
      }
      try {
        await api.post(
          `${base}/complete`,
          { state: authorization.state, code: event.data.code },
          options
        );
        finish();
      } catch (error) {
        finish(error);
      }
    };
    const closedTimer = setInterval(() => {
      if (tab.closed) finish(cancelled());
    }, 1000);
    const timeout = setTimeout(
      () => finish(new Error('Canva sign-in timed out. Please try again.')),
      600000
    );
    window.addEventListener('message', onMessage);
    signal?.addEventListener('abort', onAbort, { once: true });
    if (signal?.aborted) {
      onAbort();
      return;
    }
    tab.location.href = authorization.authorization_url;
  });
}
